import { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
	Button,
	Card,
	Col,
	Form,
	Input,
	List,
	PageHeader,
	Row,
	Select,
} from "antd";

import {
	CheckPermission,
	ObjectNumbersToEnglish,
	PersianNumberToEnglish,
	PriceFormat,
} from "scripts/helpers";
import { setRoute, updateSettings } from "scripts/reducer";
import { Permissions } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";
import Rules from "scripts/rules";

import InputCurrency from "components/InputCurrency";

const Component = ({
	cities,
	onSetRoute,
	onUpdateSettings,
	parentName,
	permissions,
	provinces,
	routeName,
	settings,
}) => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { submitting } = state;
	const [form] = Form.useForm();
	const currency =
		settings.appCurrency === "T" ? Resources.toman : Resources.rial;

	const handleSubmit = () => {
		if (!submitting) {
			form.validateFields().then((values) => {
				setState((prevState) => ({ ...prevState, submitting: true }));

				values = ObjectNumbersToEnglish(values);

				values.specialJobsQuantity = PersianNumberToEnglish(
					values.specialJobsQuantity
				);
				values.nearbyRadius = PersianNumberToEnglish(values.nearbyRadius);

				API.settings
					.update(values)
					.then(({ data }) => {
						onUpdateSettings(data);
					})
					.finally(() => {
						setState((prevState) => ({
							...prevState,
							submitting: false,
						}));
					});
			});
		}
	};

	const componentDidMount = () => {
		onSetRoute({ openKey: parentName, selectedKey: routeName });

		if (permissions.update) {
			form.setFieldsValue({
				...settings,
				defaultCityId: settings.defaultCity.id,
			});
		}
	};

	useEffect(componentDidMount, []);

	return (
		<>
			<PageHeader title={Resources.settings} />
			<Row className="sp-content-center">
				<Col
					xs={24}
					md={18}
					lg={12}
				>
					<Card>
						{permissions.update ? (
							<>
								<Form
									layout="vertical"
									form={form}
								>
									<Row gutter={[16, 8]}>
										{/* <Col xs={24}>
											<Form.Item
												name="appCurrency"
												label={Resources.currency}
											>
												<Select
													options={[
														{
															value: "R",
															label: Resources.rial,
														},
														{
															value: "T",
															label: Resources.toman,
														},
													]}
												/>
											</Form.Item>
										</Col> */}
										<Col xs={24}>
											<Form.Item
												name="ladderPricing"
												label={Resources.ladderPricing}
												rules={Rules.required}
											>
												<InputCurrency />
											</Form.Item>
										</Col>

										<Col xs={24}>
											<Form.Item
												name="defaultCityId"
												label={`${Resources.city} ${Resources.default}`}
												rules={Rules.required}
											>
												<Select
													placeholder={Resources.city}
													optionFilterProp="label"
													showSearch
												>
													{provinces.map((p) => (
														<Select.OptGroup
															key={p.id}
															label={p.name}
														>
															{cities
																.filter(
																	(c) => Number(c.provinceId) === Number(p.id)
																)
																.map((c) => (
																	<Select.Option
																		key={c.id}
																		province={p.id}
																		value={c.id}
																		label={c.name}
																	>
																		{c.name}
																	</Select.Option>
																))}
														</Select.OptGroup>
													))}
												</Select>
											</Form.Item>
										</Col>

										<Col xs={24}>
											<Form.Item
												name="nearbyRadius"
												label={Resources.nearbyRadius}
												rules={Rules.required}
											>
												<Input suffix={Resources.kilometer} />
											</Form.Item>
										</Col>
										<Col xs={24}>
											<Form.Item
												name="specialJobsQuantity"
												label={`${Resources.count} ${Resources.jobs} ${Resources.special}`}
												rules={Rules.required}
											>
												<Input />
											</Form.Item>
										</Col>
										<Col xs={24}>
											<Form.Item
												name="specialJobPricePerDay"
												label={`${Resources.cost} ${Resources.daily} ${Resources.jobs} ${Resources.special}`}
												rules={Rules.required}
											>
												<InputCurrency />
											</Form.Item>
										</Col>
										<Col xs={24}>
											<Form.Item
												name="jobDescription"
												label={`${Resources.description} ${Resources.record} ${Resources.job}`}
												rules={Rules.required}
											>
												<Input.TextArea rows={4} />
											</Form.Item>
										</Col>
										<Col xs={24}>
											<Form.Item
												name="ladderDescription"
												label={`${Resources.description} ${Resources.action} ${Resources.ladder}${Resources.y}`}
												rules={Rules.required}
											>
												<Input.TextArea rows={4} />
											</Form.Item>
										</Col>
										<Col xs={24}>
											<Form.Item
												name="subscriptionDescription"
												label={`${Resources.description} ${Resources.subscription}`}
												rules={Rules.required}
											>
												<Input.TextArea rows={4} />
											</Form.Item>
										</Col>
										<Col xs={24}>
											<Form.Item
												name="bannerDescription"
												label={`${Resources.description} ${Resources.record} ${Resources.banner}`}
												rules={Rules.required}
											>
												<Input.TextArea rows={4} />
											</Form.Item>
										</Col>
										<Col xs={24}>
											<Form.Item
												name="specialJobDescription"
												label={`${Resources.description} ${Resources.jobs} ${Resources.special}`}
												rules={Rules.required}
											>
												<Input.TextArea rows={4} />
											</Form.Item>
										</Col>
										<Col xs={24}>
											<Form.Item
												name="shareDescription"
												label={`${Resources.text} ${Resources.sharing}`}
												rules={Rules.required}
											>
												<Input.TextArea rows={4} />
											</Form.Item>
										</Col>
										<Col xs={24}>
											<Form.Item
												name="footerText"
												label={`${Resources.text} ${Resources.footer}`}
												rules={Rules.required}
											>
												<Input.TextArea rows={4} />
											</Form.Item>
										</Col>
									</Row>
								</Form>
								<Button
									type="primary"
									onClick={handleSubmit}
									loading={submitting}
									style={{ float: "left", marginTop: 16 }}
								>
									{Resources.confirm}
								</Button>
							</>
						) : (
							<List>
								<List.Item>
									<List.Item.Meta
										title={Resources.currency}
										description={currency}
									/>
								</List.Item>
								<List.Item>
									<List.Item.Meta
										title={Resources.basicPricing}
										description={`${PriceFormat(
											settings.basicPricing
										)} ${currency}`}
									/>
								</List.Item>
								<List.Item>
									<List.Item.Meta
										title={Resources.ladderPricing}
										description={`${PriceFormat(
											settings.ladderPricing
										)} ${currency}`}
									/>
								</List.Item>
								<List.Item>
									<List.Item.Meta
										title={`${Resources.city} ${Resources.default}`}
										description={`${settings.defaultCity?.name} (${settings.defaultProvince?.name})`}
									/>
								</List.Item>
								<List.Item>
									<List.Item.Meta
										title={Resources.nearbyRadius}
										description={`${settings.nearbyRadius} ${Resources.meter}`}
									/>
								</List.Item>
								<List.Item>
									<List.Item.Meta
										title={`${Resources.count} ${Resources.jobs} ${Resources.special}`}
										description={settings.specialJobsQuantity}
									/>
								</List.Item>
								<List.Item>
									<List.Item.Meta
										title={`${Resources.cost} ${Resources.daily} ${Resources.jobs} ${Resources.special}`}
										description={settings.specialJobPricePerDay}
									/>
								</List.Item>
								<List.Item>
									<List.Item.Meta
										title={`${Resources.description} ${Resources.record} ${Resources.job}`}
										description={settings.jobDescription}
									/>
								</List.Item>
								<List.Item>
									<List.Item.Meta
										title={`${Resources.description} ${Resources.action} ${Resources.ladder}${Resources.y}`}
										description={settings.ladderDescription}
									/>
								</List.Item>
								<List.Item>
									<List.Item.Meta
										title={`${Resources.description} ${Resources.subscription}`}
										description={settings.subscriptionDescription}
									/>
								</List.Item>
								<List.Item>
									<List.Item.Meta
										title={`${Resources.description} ${Resources.record} ${Resources.banner}`}
										description={settings.bannerDescription}
									/>
								</List.Item>
								<List.Item>
									<List.Item.Meta
										title={`${Resources.description} ${Resources.jobs} ${Resources.special}`}
										description={settings.specialJobDescription}
									/>
								</List.Item>
								<List.Item>
									<List.Item.Meta
										title={`${Resources.text} ${Resources.footer}`}
										description={settings.footerText}
									/>
								</List.Item>
							</List>
						)}
					</Card>
				</Col>
			</Row>
		</>
	);
};

export default connect(
	(state) => {
		return {
			cities: state.cities,
			provinces: state.provinces,
			settings: state.settings,
			permissions: {
				update: CheckPermission(
					state.user.permissions,
					Permissions.SETTING_UPDATE
				),
			},
		};
	},
	(dispatch) => {
		return {
			onSetRoute: (data) => dispatch(setRoute(data)),
			onUpdateSettings: (data) => dispatch(updateSettings(data)),
		};
	}
)(Component);
